// src/LoginPage.js - Super Admin Dashboard
//
// GoTrue-login-cutover task (2026-07-06): replaces Firebase's
// `signInWithEmailAndPassword` with GoTrue's password grant
// (`supabase.auth.signInWithPassword`). `App.js` still does the "am I really
// a super admin" check after this resolves (now via a backend `/whoami` call
// instead of a direct Firestore query).

import React, { useState } from 'react';
import { supabase } from './supabaseClient';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const { error: authError } = await supabase.auth.signInWithPassword({ email, password });
      if (authError) throw authError;
      // سيتم التحقق من أنه Super Admin في App.js
    } catch (err) {
      console.error("Login Error:", err.status, err.message);
      // GoTrue بيرجع رسالة نصية + HTTP status، مش أكواد زي Firebase
      // (auth/wrong-password...) — بنطابق الرسايل الشائعة على نفس النصوص
      // العربي القديمة.
      const message = String(err.message || '');
      if (/invalid login credentials/i.test(message) || /invalid email/i.test(message)) {
        setError("الإيميل أو الباسورد غلط، حاول تاني.");
      } else if (err.status === 429 || /rate limit/i.test(message)) {
        setError("محاولات كتير غلط، استنى شوية وحاول تاني.");
      } else {
        setError("حصل خطأ غير متوقع، حاول تاني.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.backgroundContainer}>
      <div style={styles.overlay}></div>
      <div style={styles.loginCard}>
        <h1 style={styles.logo}>🔐 Super Admin</h1>
        <h2 style={{ marginBottom: '30px', fontWeight: 'normal' }}>
          لوحة التحكم الرئيسية
        </h2>

        <form onSubmit={handleLogin}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="البريد الإلكتروني"
            required
            style={styles.input}
            disabled={loading}
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="كلمة المرور"
            required
            style={styles.input}
            disabled={loading}
          />
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'جاري الدخول...' : 'تسجيل الدخول'}
          </button>
          {error && <p style={styles.errorText}>{error}</p>}
        </form>
      </div>
    </div>
  );
}

const styles = {
  backgroundContainer: {
    background: 'linear-gradient(135deg, #1e1e2f 0%, #282a36 100%)',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  overlay: {
    position: 'absolute',
    top: 0, 
    left: 0, 
    right: 0, 
    bottom: 0,
    background: 'radial-gradient(circle at 50% 50%, rgba(189, 147, 249, 0.1) 0%, transparent 50%)',
    zIndex: 1,
  },
  loginCard: {
    position: 'relative',
    zIndex: 2,
    backgroundColor: 'rgba(40, 42, 54, 0.95)',
    backdropFilter: 'blur(15px)',
    border: '2px solid #bd93f9',
    borderRadius: '15px',
    padding: '40px 30px',
    boxShadow: '0 8px 32px 0 rgba(189, 147, 249, 0.3)',
    maxWidth: '400px',
    width: '90%',
    textAlign: 'center',
    color: 'white',
  },
  logo: {
    fontSize: '3em',
    marginBottom: '10px',
    color: '#bd93f9',
  },
  input: {
    display: 'block',
    width: 'calc(100% - 22px)',
    padding: '12px 10px',
    marginBottom: '15px',
    fontSize: '16px',
    background: 'rgba(68, 71, 90, 0.5)',
    border: '1px solid #6272a4',
    borderRadius: '5px',
    color: 'white',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border-color 0.3s ease',
  },
  button: {
    display: 'block',
    width: '100%',
    padding: '12px',
    fontSize: '16px',
    fontWeight: 'bold',
    background: '#bd93f9',
    color: '#282a36',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '10px',
    transition: 'all 0.3s ease',
  },
  errorText: {
    color: '#ff5555',
    textAlign: 'center',
    marginTop: '15px',
    fontSize: '14px',
  },
};

export default LoginPage;
